import { getSeatLayoutById } from '../get-seat-layout-by-id';
import { getAreaCategoriesByIds } from './get-area-categories-by-ids';
export const getAreaCategoriesForSeatLayout = (seatLayoutId) => {
    const seatLayout = getSeatLayoutById(seatLayoutId);
    if (!seatLayout) {
        throw new Error(`Cannot find seat layout with ID ${seatLayoutId}.`);
    }
    const areaCategoryIds = new Set();
    seatLayout.areas.forEach(({ areaCategoryId }) => areaCategoryIds.add(areaCategoryId));
    return getAreaCategoriesByIds(Array.from(areaCategoryIds));
};
//# sourceMappingURL=get-area-categories-for-seat-layout.js.map